export default __webpack_public_path__ + "static/media/lili.45bc45cd.jpg";